exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3vSxxogePY-UhaJscrtuuF{height:100%}html[dir] ._3vSxxogePY-UhaJscrtuuF{background-color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._3vSxxogePY-UhaJscrtuuF._1IYaUphyDdESkvBdLEAdHq{background-color:#a80000}._2K4jLGrotKja_bnnCfBKVy{height:20px;width:100%}html[dir] ._2K4jLGrotKja_bnnCfBKVy{margin:10px 0;background-color:\"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] ._1QGR_TaLQcYMk_EdCKpLgP{margin-right:8px}html[dir=rtl] ._1QGR_TaLQcYMk_EdCKpLgP{margin-left:8px}._3l40lzrHTty_QbTBNSCgJy{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"mailboxStorageUsed": "_3vSxxogePY-UhaJscrtuuF",
	"exceededQuota": "_1IYaUphyDdESkvBdLEAdHq",
	"usageContainer": "_2K4jLGrotKja_bnnCfBKVy",
	"icon": "_1QGR_TaLQcYMk_EdCKpLgP",
	"warningText": "_3l40lzrHTty_QbTBNSCgJy"
};